module.exports = __webpack_public_path__ + "static/media/logo_oculus.f81fd530.png";